import { render } from "./EsimDirectory.vue?vue&type=template&id=b2c67d94&scoped=true&ts=true"
import script from "./EsimDirectory.vue?vue&type=script&lang=ts"
export * from "./EsimDirectory.vue?vue&type=script&lang=ts"

import "./EsimDirectory.vue?vue&type=style&index=0&id=b2c67d94&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c67d94"]])

export default __exports__